import { Component, LOCALE_ID, OnInit, inject } from '@angular/core';
import { OptionalTranslationHelper } from '@orgbrain/lib-data';

@Component({
  selector: 'orgbrain-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  locale = inject(LOCALE_ID);

  helper = new OptionalTranslationHelper(null, this.locale);

  ngOnInit() {}
}
